/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import './devices-admin.scss';

/* eslint-disable import/no-unresolved, import/default */

import deviceCredentialsTemplate from '../../../../../device/device-credentials.tpl.html';
import devicesAdminTemplate from './devices-admin.tpl.html';
import addDeviceTemplate from './add-device.tpl.html';
import addTemperatureCablesTemplate from './cables-wizard/add-temperature-cables.tpl.html';

/* eslint-enable import/no-unresolved, import/default */



export default angular.module('agrolog.admin.devicesAdmin', [])
    .directive('agDevicesAdmin', DevicesAdmin)
    .name;

/*@ngInject*/
function DevicesAdmin() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            ctx: '=',
            userMode: '='
        },
        controller: DevicesAdminController,
        controllerAs: 'vm',
        templateUrl: devicesAdminTemplate
    };
}

/* eslint-disable angular/angularelement */


/*@ngInject*/
function DevicesAdminController($rootScope, $log, $scope, $document, $window, $mdDialog, $q, $filter, $mdMedia,
                                   $translate, toast, agTypes, types, userService, entityService, attributeService, agDeviceService) {

    let vm = this;

    vm.agTypes = agTypes;
    vm.types = types;

    vm.showData = userService.getAuthority() === 'TENANT_ADMIN' || userService.getAuthority() === "CUSTOMER_USER";
    vm.hasData = false;

    vm.devices = [];
    vm.devicesCount = 0;
    vm.allDevices = [];
    vm.selectedDevices = [];

    vm.displayPagination = true;

    vm.currentDevice = null;

    vm.query = {
        order: 'name',
        limit: 5,
        page: 1,
        search: null
    };

    vm.addDeviceAction = {
        name: 'ag.device.add',
        show: true,
        onAction: function($event) {
            vm.addDevice($event);
        },
        icon: 'add'
    };

    vm.addTemperatureCablesAction = {
        name: 'ag.device.temperature-cables-wizard',
        show: true,
        onAction: function($event) {
            vm.addTemperatureCables($event);
        },
        icon: 'my_library_add'
    };

    vm.searchAction = {
        name: 'action.search',
        show: true,
        onAction: function() {
            vm.enterFilterMode();
        },
        icon: 'search'
    };

    vm.refreshAction = {
        name: 'action.refresh',
        show: true,
        onAction: function() {
            vm.reloadDevices();
        },
        icon: 'refresh'
    };

    vm.onRowClick = onRowClick;
    vm.isCurrent = isCurrent;
    vm.enterFilterMode = enterFilterMode;
    vm.exitFilterMode = exitFilterMode;
    vm.onReorder = onReorder;
    vm.onPaginate = onPaginate;
    vm.addDevice = addDevice;
    vm.addTemperatureCables = addTemperatureCables;
    vm.manageCredentials = manageCredentials;
    vm.deleteDevice = deleteDevice;
    vm.deleteDevices = deleteDevices;
    vm.reloadDevices = reloadDevices;
    vm.updateDevices = updateDevices;

    vm.extraDevicesFilter = (device) => {
        return device.type === agTypes.deviceType.moistureSensorLines || device.type === agTypes.deviceType.co2SensorLines || device.type === agTypes.deviceType.levelIndicator || device.type === agTypes.deviceType.headSpaceSensor;
    };

    $scope.$watch(function() { return $mdMedia('gt-xs'); }, function(isGtXs) {
        vm.isGtXs = isGtXs;
    });

    $scope.$watch(function() { return $mdMedia('gt-md'); }, function(isGtMd) {
        vm.isGtMd = isGtMd;
        if (vm.isGtMd) {
            vm.limitOptions = [5, 10, 15];
        } else {
            vm.limitOptions = null;
        }
    });

    $scope.$watch('vm.devices', function () {
        if (vm.userMode) {
            $log.info('devices', vm.devices)
            // TODO: check SMS mode for config
            //$log.info('')
        }
    })

    $scope.$watch('vm.ctx', function () {
        if (vm.showData && vm.ctx) {
            vm.isEdit = vm.ctx.isEdit;
            if (vm.userMode) {
                vm.ctx.widgetActions = [vm.searchAction, vm.refreshAction];
            } else {
                vm.ctx.widgetActions = [vm.addDeviceAction, vm.addTemperatureCablesAction, vm.searchAction, vm.refreshAction];
            }
            vm.ctx.widgetTitle = $translate.instant('ag.device.devices') + '';
            vm.displayPagination = angular.isDefined(vm.ctx.settings.displayPagination) ? vm.ctx.settings.displayPagination : true;
            reloadDevices();
        }
    });

    $scope.$on('editModeChanged', function() {
        vm.isEdit = vm.ctx.isEdit;
    });

    $scope.$watch("vm.query.search", function(newVal, prevVal) {
        if (!angular.equals(newVal, prevVal) && vm.query.search != null) {
            updateDevices();
        }
    });

    $scope.$on('deviceUpdated', function(event, device) {
        deviceUpdated(device);
    });

    function deviceUpdated(device) {
        var result = $filter('filter')(vm.allDevices, {id: { id: device.id.id } }, true);
        if (result && result.length) {
            var prevDevice = result[0];
            var index = vm.allDevices.indexOf(prevDevice);
            vm.allDevices[index] = device;
            index = vm.devices.indexOf(prevDevice);
            if (index > -1) {
                vm.devices[index] = device;
            }
        }
    }

    $scope.$watch('vm.selectedDevices.length', function (newLength) {
        var selectionMode = newLength ? true : false;
        if (vm.ctx) {
            if (selectionMode) {
                vm.ctx.hideTitlePanel = true;
            } else if (vm.query.search == null) {
                vm.ctx.hideTitlePanel = false;
            }
        }
    });

    function onRowClick($event, device) {
        if (vm.currentDevice != device) {
            vm.currentDevice = device;
        }
        vm.ctx.stateController.openRightLayout();
        $rootScope.$broadcast('deviceSelected', device.id);
    }

    function isCurrent(device) {
        return (vm.currentDevice && device) &&
            (vm.currentDevice.id.id === device.id.id);
    }

    function enterFilterMode () {
        vm.query.search = '';
        vm.ctx.hideTitlePanel = true;
    }

    function exitFilterMode () {
        vm.query.search = null;
        updateDevices();
        vm.ctx.hideTitlePanel = false;
    }

    function onReorder () {
        updateDevices();
    }

    function onPaginate () {
        updateDevices();
    }

    function addDevice($event) {
        if ($event) {
            $event.stopPropagation();
        }
        $mdDialog.show({
            controller: AddDeviceController,
            controllerAs: 'vm',
            templateUrl: addDeviceTemplate,
            parent: angular.element($document[0].body),
            locals: {
                allDevices: vm.allDevices
            },
            fullscreen: true,
            skipHide: true,
            targetEvent: $event,
            onComplete: function () {
                var w = angular.element($window);
                w.triggerHandler('resize');
            }
        }).then(function () {
            reloadDevices();
        }, function () {
        });
    }

    function addTemperatureCables($event) {
        if ($event) {
            $event.stopPropagation();
        }
        $mdDialog.show({
            controller: 'AddTemperatureCablesController',
            controllerAs: 'vm',
            templateUrl: addTemperatureCablesTemplate,
            parent: angular.element($document[0].body),
            locals: {
            },
            fullscreen: true,
            skipHide: true,
            targetEvent: $event,
            onComplete: function () {
                var w = angular.element($window);
                w.triggerHandler('resize');
            }
        }).then(function () {
            reloadDevices();
        }, function () {
        });
    }

    function manageCredentials($event, device) {
        if ($event) {
            $event.stopPropagation();
        }
        $mdDialog.show({
            controller: 'ManageDeviceCredentialsController',
            controllerAs: 'vm',
            templateUrl: deviceCredentialsTemplate,
            locals: {deviceId: device.id.id, isReadOnly: false},
            parent: angular.element($document[0].body),
            fullscreen: true,
            targetEvent: $event
        }).then(function () {
        }, function () {
        });
    }

    function deleteDevice($event, device) {
        if ($event) {
            $event.stopPropagation();
        }
        if (device) {
            var name = device.name;
            var title = $translate.instant('ag.device.delete-device-title', {deviceName: name});
            var content = $translate.instant('ag.device.delete-device-text');
            var confirm = $mdDialog.confirm()
                .targetEvent($event)
                .title(title)
                .htmlContent(content)
                .ariaLabel(title)
                .cancel($translate.instant('action.no'))
                .ok($translate.instant('action.yes'));
            $mdDialog.show(confirm).then(() => {
                if (device.type === agTypes.deviceType.moistureSensorLines || device.type === agTypes.deviceType.co2SensorLines || device.type === agTypes.deviceType.levelIndicator || device.type === agTypes.deviceType.headSpaceSensor) {
                    agDeviceService.findParentSilo(device.id.id).then(
                        (parent) => {
                            if (parent) {
                                entityService.getRelatedEntities(parent.id, types.entityType.device, [device.type], 1).then(
                                    (devices) => {
                                        agDeviceService.deleteDevice(device.id, (error) => { toast.showError(error) }).then(
                                            () => {
                                                if (devices.length === 1) {
                                                    let targetKey;
                                                    if (device.type === agTypes.deviceType.moistureSensorLines) {
                                                        targetKey = agTypes.attributes.silo.hasMoistureCables;
                                                    } else if (device.type === agTypes.deviceType.co2SensorLines) {
                                                        targetKey = agTypes.attributes.silo.hasCO2Cables;
                                                    } else if (device.type === agTypes.deviceType.levelIndicator) {
                                                        targetKey = agTypes.attributes.silo.hasLevelIndicator;
                                                    } else if (device.type === agTypes.deviceType.headSpaceSensor) {
                                                        targetKey = agTypes.attributes.silo.hasHeadSpaceSensor
                                                    }
                                                    attributeService.saveEntityAttributes(parent.id.entityType, parent.id.id,
                                                        types.attributesScope.server.value, [{key: targetKey, value: false}]).then(() => {
                                                        }
                                                    );
                                                }
                                                reloadDevices();
                                            }
                                        );
                                    }
                                );
                            } else {
                                agDeviceService.deleteDevice(device.id, (error) => { toast.showError(error) }).then(
                                    () => {
                                        reloadDevices();
                                    }
                                );
                            }
                        }
                    );
                } else {
                    agDeviceService.deleteDevice(device.id, (error) => { toast.showError(error) }).then(
                        () => {
                            reloadDevices();
                        }
                    );
                }
            });
        }
    }

    function deleteDevices($event) {
        if ($event) {
            $event.stopPropagation();
        }
        if (vm.selectedDevices && vm.selectedDevices.length > 0) {
            var title = $translate.instant('ag.device.delete-devices-title', {count: vm.selectedDevices.length}, 'messageformat');
            var content = $translate.instant('ag.device.delete-devices-text');
            var confirm = $mdDialog.confirm()
                .targetEvent($event)
                .title(title)
                .htmlContent(content)
                .ariaLabel(title)
                .cancel($translate.instant('action.no'))
                .ok($translate.instant('action.yes'));
            $mdDialog.show(confirm).then(function () {
                var tasks = [], i;
                var extraDevices = $filter('filter')(vm.selectedDevices, vm.extraDevicesFilter);
                if (extraDevices.length) {
                    var findParentsTasks = [];
                    for (i = 0; i < extraDevices.length; i++) {
                        findParentsTasks.push(agDeviceService.findParentSilo(extraDevices[i].id.id));
                    }
                    $q.all(findParentsTasks).then(
                        (parents) => {
                            var validParents = [];
                            for (i = 0; i < parents.length; i++) {
                                if (parents[i]) {
                                    parents[i].deleteMoisture = [];
                                    parents[i].deleteCO2 = [];
                                    parents[i].deleteCropLevel = [];
                                    parents[i].deleteHeadSpace = [];
                                    validParents.push(parents[i]);
                                }
                            }
                            if (validParents.length) {
                                var uniqueParents = [];
                                for (i = 0; i < validParents.length; i++) {
                                    var result = $filter('filter')(uniqueParents, {id: { id: validParents[i].id.id } });
                                    if (!result.length) {
                                        uniqueParents.push(validParents[i]);
                                    }
                                }
                                for (i = 0; i < extraDevices.length; i++) {
                                    if (parents[i]) {
                                        result = $filter('filter')(uniqueParents, {id: { id: parents[i].id.id } });
                                        if (extraDevices[i].type === agTypes.deviceType.moistureSensorLines) {
                                            result[0].deleteMoisture.push(extraDevices[i]);
                                        } else if (extraDevices[i].type === agTypes.deviceType.co2SensorLines) {
                                            result[0].deleteCO2.push(extraDevices[i]);
                                        } else if (extraDevices[i].type === agTypes.deviceType.levelIndicator) {
                                            result[0].deleteCropLevel.push(extraDevices[i]);
                                        } else if (extraDevices[i].type === agTypes.deviceType.headSpaceSensor) {
                                            result[0].deleteHeadSpace.push(extraDevices[i]);
                                        }
                                    }
                                }
                                var extraDevicesTasks = [];
                                for (i = 0; i < uniqueParents.length; i++) {
                                    extraDevicesTasks.push(entityService.getRelatedEntities(uniqueParents[i].id, types.entityType.device, [agTypes.deviceType.moistureSensorLines,
                                        agTypes.deviceType.co2SensorLines, agTypes.deviceType.levelIndicator, agTypes.deviceType.headSpaceSensor], 1));
                                }
                                $q.all(extraDevicesTasks).then(
                                    (extraDevicesPayload) => {
                                        for (i = 0; i < vm.selectedDevices.length; i++) {
                                            tasks.push(agDeviceService.deleteDevice(vm.selectedDevices[i].id, (error) => { toast.showError(error) }));
                                        }
                                        $q.all(tasks).then(() => {
                                            var extraAttributeTasks = [];
                                            for (i = 0; i < uniqueParents.length; i++) {
                                                let updatedKeys = [];
                                                if (uniqueParents[i].deleteMoisture.length) {
                                                    let result = $filter('filter')(extraDevicesPayload[i], {type: agTypes.deviceType.moistureSensorLines});
                                                    if (uniqueParents[i].deleteMoisture.length === result.length) {
                                                        updatedKeys.push({key: agTypes.attributes.silo.hasMoistureCables, value: false});
                                                    }
                                                }
                                                if (uniqueParents[i].deleteCO2.length) {
                                                    let result = $filter('filter')(extraDevicesPayload[i], {type: agTypes.deviceType.co2SensorLines});
                                                    if (uniqueParents[i].deleteCO2.length === result.length) {
                                                        updatedKeys.push({key: agTypes.attributes.silo.hasCO2Cables, value: false});
                                                    }
                                                }
                                                if (uniqueParents[i].deleteCropLevel.length) {
                                                    let result = $filter('filter')(extraDevicesPayload[i], {type: agTypes.deviceType.levelIndicator});
                                                    if (uniqueParents[i].deleteCropLevel.length === result.length) {
                                                        updatedKeys.push({key: agTypes.attributes.silo.hasLevelIndicator, value: false});
                                                    }
                                                }
                                                if (uniqueParents[i].deleteHeadSpace.length) {
                                                    let result = $filter('filter')(extraDevicesPayload[i], {type: agTypes.deviceType.headSpaceSensor});
                                                    if (uniqueParents[i].deleteHeadSpace.length === result.length) {
                                                        updatedKeys.push({key: agTypes.attributes.silo.hasHeadSpaceSensor, value: false});
                                                    }
                                                }
                                                if (updatedKeys.length) {
                                                    extraAttributeTasks.push(attributeService.saveEntityAttributes(uniqueParents[i].id.entityType, uniqueParents[i].id.id, types.attributesScope.server.value, updatedKeys));
                                                }
                                            }
                                            if (extraAttributeTasks.length) {
                                                $q.all(extraAttributeTasks).then(() => {
                                                });
                                            }
                                            reloadDevices();
                                        });
                                    }
                                );
                            } else {
                                for (i = 0; i < vm.selectedDevices.length; i++) {
                                    tasks.push(agDeviceService.deleteDevice(vm.selectedDevices[i].id, (error) => { toast.showError(error) }));
                                }
                                $q.all(tasks).then(() => {
                                    reloadDevices();
                                });
                            }
                        }
                    );

                } else {
                    for (i = 0; i < vm.selectedDevices.length; i++) {
                        tasks.push(agDeviceService.deleteDevice(vm.selectedDevices[i].id, (error) => { toast.showError(error) }));
                    }
                    $q.all(tasks).then(() => {
                        reloadDevices();
                    });
                }

            });
        }
    }

    function reloadDevices (keepSelection) {
        vm.allDevices.length = 0;
        vm.devices.length = 0;
        if (!keepSelection) {
            vm.currentDevice = null;
        }
        if(vm.userMode) {
            vm.devicesPromise = agDeviceService.getAllSubsystems();
        } else {
            vm.devicesPromise = agDeviceService.getAllDevices();
        }
        vm.devicesPromise.then(
            (allDevices) => {
                vm.allDevices = allDevices;
                vm.selectedDevices = [];
                vm.updateDevices();
                vm.devicesPromise = null;
            }, () => {
                vm.allDevices = [];
                vm.selectedDevices = [];
                vm.updateDevices();
                vm.devicesPromise = null;
            }
        );
    }

    function updateDevices () {
        vm.selectedDevices = [];
        var result = $filter('orderBy')(vm.allDevices, vm.query.order);
        if (vm.query.search != null) {
            result = $filter('filter')(result, {$: vm.query.search});
        }
        vm.devicesCount = result.length;

        if (vm.displayPagination) {
            var startIndex = vm.query.limit * (vm.query.page - 1);
            vm.devices = result.slice(startIndex, startIndex + vm.query.limit);
        } else {
            vm.devices = result;
        }
    }

}

/*@ngInject*/
function AddDeviceController($scope, $mdDialog, $filter,  $q, toast, types, agTypes, agDeviceService, allDevices) {

    var vm = this;

    vm.types = types;
    vm.agTypes = agTypes;

    vm.device = {
        type: null
    };
    vm.deviceTypes = [];
    for (var deviceType in agTypes.deviceType) {
        vm.deviceTypes.push(agTypes.deviceType[deviceType]);
    }

    vm.add = add;
    vm.cancel = cancel;

    function cancel() {
        $mdDialog.cancel();
    }

    function add() {
        createNewDevice().then(
            function() {
                $scope.theForm.$setPristine();
                $mdDialog.hide();
            }
        );
    }

    function createNewDevice() {
        var deferred = $q.defer();
        if(vm.device.type !== vm.agTypes.deviceType.generic && vm.device.type !== vm.agTypes.deviceType.default) {
            vm.device.name = createDeviceName();
        }
        agDeviceService.saveDevice(vm.device, (error) => {
                toast.showError(error);
            }
        ).then(
            function success(device) {
                vm.device = device;
                deferred.resolve();
            },
            function fail() {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function createDeviceName() {
        var productionDateString = $filter('date')(vm.productionDate, 'ddMMyy');
        var batchNumString = pad(vm.batchNumber, 2);
        var productionDateAndButch = productionDateString + '-' + batchNumString;
        var deviceNumber = 1;
        var nameCore;

        if (vm.device.type === vm.agTypes.deviceType.gateway) {
            nameCore = buildNameCore(agTypes.deviceNamePrefix.gateway, productionDateAndButch, agTypes.deviceNameSuffix.gateway);
        } else if (vm.device.type === vm.agTypes.deviceType.relay) {
            nameCore = buildNameCore(agTypes.deviceNamePrefix.relay, productionDateAndButch, agTypes.deviceNameSuffix.relay);
        } else if (vm.device.type === vm.agTypes.deviceType.temperatureSensorLines) {
            nameCore = buildNameCore(agTypes.deviceNamePrefix.temperatureSensorLines, productionDateAndButch, agTypes.deviceNameSuffix.temperatureSensorLines);
        } else if (vm.device.type === vm.agTypes.deviceType.moistureSensorLines) {
            nameCore = buildNameCore(agTypes.deviceNamePrefix.moistureSensorLines, productionDateAndButch, agTypes.deviceNameSuffix.moistureSensorLines);
        } else if (vm.device.type === vm.agTypes.deviceType.co2SensorLines) {
            nameCore = buildNameCore(agTypes.deviceNamePrefix.co2SensorLines, productionDateAndButch, agTypes.deviceNameSuffix.co2SensorLines);
        } else if (vm.device.type === vm.agTypes.deviceType.weatherStation) {
            nameCore = buildNameCore(agTypes.deviceNamePrefix.weatherStation, productionDateAndButch, agTypes.deviceNameSuffix.weatherStation);
        } else if (vm.device.type === vm.agTypes.deviceType.levelIndicator) {
            nameCore = buildNameCore(agTypes.deviceNamePrefix.levelIndicator, productionDateAndButch, agTypes.deviceNameSuffix.levelIndicator);
        } else if (vm.device.type === vm.agTypes.deviceType.headSpaceSensor) {
            nameCore = buildNameCore(agTypes.deviceNamePrefix.headSpaceSensor, productionDateAndButch, agTypes.deviceNameSuffix.headSpaceSensor);
        } else if (vm.device.type === vm.agTypes.deviceType.sms) {
            nameCore = buildNameCore(agTypes.deviceNamePrefix.sms, productionDateAndButch, agTypes.deviceNameSuffix.sms);
        } else if (vm.device.type === vm.agTypes.deviceType.relaySystem) {
            nameCore = buildNameCore(agTypes.deviceNamePrefix.relaySystem, productionDateAndButch, agTypes.deviceNameSuffix.relaySystem);
        } else if (vm.device.type === vm.agTypes.deviceType.modbus) {
            nameCore = buildNameCore(agTypes.deviceNamePrefix.modbus, productionDateAndButch, agTypes.deviceNameSuffix.modbus);
        }
        if (vm.device.lineNumber) {
            return setDeviceNumber(nameCore, vm.device.lineNumber);
        } else {
            var result = setDeviceNumber(nameCore, deviceNumber);
            for (var i = 0; i <= allDevices.length; i++) {
                var matchesResult = $filter('filter')(allDevices, {name: result}, true);
                if (!matchesResult.length) {
                    return result;
                } else {
                    result = setDeviceNumber(nameCore, ++deviceNumber);
                }
            }
        }
    }

    function buildNameCore(prefix, productionDateAndButch, suffix) {
        return prefix + productionDateAndButch + suffix;
    }

    function setDeviceNumber(nameCore, deviceNumber) {
        return nameCore + pad(deviceNumber, 3);
    }

    function pad(num, size) {
        var s = num + "";
        while (s.length < size) s = "0" + s;
        return s;
    }
}
